import React from 'react'

const About = () => {
    return (
        <>
            <div className='container my-2 py-3' >
                <div className='row'>
                    <div className='col-12 mb-1'>
                        <div><h1 className='fw-bolder text-center mt-1'> About </h1><hr />
                        <blockquote class="blockquote text-center">
                        <p className='mb-0'>React Shopping is India’s dominant e-commerce platforms which was started in 2007 with it’s headquarters in Bengaluru. It was founded by Sachin Bansal and Binny Bansal , this online journey had initially began as a online bookstore. The more the business surged , it grew and expanded it’s project. The platform started to sell a variety of products like mobiles , music , as well as movies. Flipkart gradually expanded with new item categories in it’s collection.

At present the company facilitates over 80+ million product starting from different ranges of over 80 categories of computers, laptops, books, e-books, sports, fitness, baby care , toys  etc.

In November 2020, according to Walmart , Flipkart had registered a large record number of monthly active customers.</p>
</blockquote>
                        </div>
                    </div>
                </div>
            </div>                  
              </>
    )
}

export default About